/**
 * Removes nested properties `prop` from `object`.
 *
 * **NB: Mutates `object`.**
 * @param {*} object
 * @param {string} prop
 * @returns {object}
 */
export default function removePropertiesDeep(object, prop) {
    for (const p of Object.keys(object)) {

        if (p === prop) {
            delete object[p];
        }
        else {
            const value = object[p];

            if (value && typeof value === 'object') {
                removePropertiesDeep(value, prop);
            }
        }
    }

    return object;
}